import { TOGGLE_NAV } from "../actions/types"

const toggleNav = () => ({
    type: TOGGLE_NAV
})
export default toggleNav;